import {Component, Input} from '@angular/core';

export interface RequisitesType {
  name: string;
  inn: string;
  city: string;
  legalAddress: string;
  telNoteAlarm?: string;
  tel?: string;
  whatsAppLink?: string;
  whatsApp?: string;
  viber?: string;
  viberLink?: string;
  telegramLink?: string;
  telegram?: string;
  email?: string;
}

@Component({
  selector: 'app-requisites',
  templateUrl: './requisites.component.html',
})
export class RequisitesComponent {
  @Input() requisites: Array<RequisitesType> | null = null;
}
